import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

import EN from './i18n/en.json';
import JA from './i18n/ja.json';

const getUserLanguage = () => window.navigator.userLanguage || window.navigator.language;

i18n.use(initReactI18next).init({
  resources: {
    en: {translation: EN},
    ja: {translation: JA},
  },
  lng: getUserLanguage(),
  fallbackLng: ['en', 'ja'],
  interpolation: {
    escapeValue: false,
  },
  compatibilityJSON: 'v3',
});

export default i18n;